function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSendRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.285 24.141l-9.271-6.83L27.32 8.504 20.285 24.14zM10 23.018v-3.97l2.68 1.974L10 23.018zM28.01 5c-.142 0-.287.016-.433.047L3.581 10.189c-1.685.361-2.154 2.542-.767 3.564l2.692 1.983 1.944-1.05L4 12.144 24.508 7.75 9.232 16l-.003-.003-1.23.665V27l6.364-4.737 4.733 3.488a1.996 1.996 0 003.009-.789l7.713-17.14C30.43 6.465 29.405 5 28.013 5z",
    fill: props.color
  }));
}

export default SvgIconSendRexOutline;